'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var UnixFS = require('ipfs-unixfs');

var _require = require('ipld-dag-pb'),
    DAGNode = _require.DAGNode;

var mc = require('multicodec');

var mh = require('multihashes');

var createNode = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(context, type, options) {
    var hashAlg, metadata, node, cid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            hashAlg = mh.names[options.hashAlg];
            metadata = new UnixFS({
              type: type,
              mode: options.mode,
              mtime: options.mtime
            });
            node = new DAGNode(metadata.marshal());
            _context.next = 5;
            return context.ipld.put(node, mc.DAG_PB, {
              cidVersion: options.cidVersion,
              hashAlg: hashAlg,
              onlyHash: !options.flush
            });

          case 5:
            cid = _context.sent;
            return _context.abrupt("return", {
              cid: cid,
              node: node
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createNode(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = createNode;